import script from "./WjgIndexComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./WjgIndexComponent.vue?vue&type=script&setup=true&lang=js"

import "./WjgIndexComponent.vue?vue&type=style&index=0&id=a1d0ddf4&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1d0ddf4"]])

export default __exports__